import { lazy } from "react";
import AuthGuard from "src/guards/AuthGuard";
import Loadable from "./Loadable";

const Hub = Loadable(lazy(() => import("src/pages/hub")));

const hub = [
  {
    path: "hub",
    element: (
      <AuthGuard>
        <Hub />
      </AuthGuard>
    ),
  },
];

export default hub;
